import React from 'react';

const PLAN_INFO = {
  pro: {
    name: 'Creator Pro',
    price: '£9.99/mo',
    color: '#8b5cf6',
    gradient: 'linear-gradient(135deg, #8b5cf6, #6366f1)',
    features: [
      '20 videos per month',
      'All 10 caption styles + 6 colours',
      'Emoji overlays',
      '1080p HD output',
      'No watermark',
      'Custom clip duration (15-30s)',
      'Batch processing (3 URLs)',
      'Priority queue'
    ]
  },
  business: {
    name: 'Business',
    price: '£24.99/mo',
    color: '#10b981',
    gradient: 'linear-gradient(135deg, #10b981, #059669)',
    features: [
      '60 videos per month',
      'Everything in Pro',
      'Custom logo & branding',
      'Up to 60s clip duration',
      'Batch processing (4 URLs)',
      '90 min max video length',
      'Advanced analytics',
      'Commercial rights',
      'Priority support'
    ]
  }
};

const UpgradeModal = ({ open, onClose, requiredPlan, featureName, currentLimit }) => {
  if (!open) return null;
  const plan = PLAN_INFO[requiredPlan] || PLAN_INFO.pro;

  return (
    <div
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(0,0,0,0.75)',
        backdropFilter: 'blur(4px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 99999,
        padding: '20px'
      }}
    >
      <div style={{
        background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
        border: '1px solid ' + plan.color + '40',
        borderRadius: '20px',
        padding: '36px 32px 32px',
        maxWidth: '460px',
        width: '100%',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 25px 60px rgba(0,0,0,0.6), 0 0 0 1px ' + plan.color + '20',
        position: 'relative',
        animation: 'modalSlide 0.3s ease-out'
      }}>
        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '14px',
            right: '14px',
            background: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.1)',
            color: '#94a3b8',
            fontSize: '18px',
            cursor: 'pointer',
            width: '32px',
            height: '32px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s'
          }}
          onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.12)'; e.currentTarget.style.color = '#fff'; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; e.currentTarget.style.color = '#94a3b8'; }}
        >×</button>

        {/* Lock icon */}
        <div style={{
          width: '64px',
          height: '64px',
          borderRadius: '16px',
          background: plan.gradient,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '28px',
          margin: '0 auto 20px',
          boxShadow: '0 10px 30px ' + plan.color + '40'
        }}>🔒</div>

        {/* Heading */}
        <h2 style={{
          color: '#ffffff',
          fontSize: '22px',
          fontWeight: '800',
          margin: '0 0 8px',
          textAlign: 'center',
          letterSpacing: '-0.3px'
        }}>{featureName} is a {plan.name} feature</h2>

        <p style={{
          color: '#94a3b8',
          fontSize: '14px',
          margin: '0 0 24px',
          textAlign: 'center',
          lineHeight: '1.5'
        }}>{currentLimit ? 'Your current plan supports videos up to ' + currentLimit + ' minutes. Upgrade' : 'Upgrade'} to unlock {featureName.toLowerCase()} and everything else included in the {plan.name} plan.</p>

        {/* Price */}
        <div style={{
          background: 'rgba(255,255,255,0.04)',
          border: '1px solid rgba(255,255,255,0.08)',
          borderRadius: '12px',
          padding: '16px 20px',
          marginBottom: '20px',
          textAlign: 'center'
        }}>
          <div style={{ color: '#64748b', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px' }}>{plan.name} Plan</div>
          <div style={{ color: '#ffffff', fontSize: '28px', fontWeight: '900', letterSpacing: '-0.5px' }}>{plan.price}</div>
          <div style={{ color: '#64748b', fontSize: '11px', marginTop: '2px' }}>Cancel anytime</div>
        </div>

        {/* Features */}
        <div style={{ marginBottom: '24px' }}>
          <div style={{ color: '#cbd5e1', fontSize: '13px', fontWeight: '700', marginBottom: '12px', letterSpacing: '0.3px' }}>What you get:</div>
          {plan.features.map((feat, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
              <span style={{
                width: '18px',
                height: '18px',
                borderRadius: '50%',
                background: plan.gradient,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '11px',
                color: '#fff',
                fontWeight: '900',
                flexShrink: 0
              }}>✓</span>
              <span style={{ color: '#e2e8f0', fontSize: '13px', lineHeight: '1.5' }}>{feat}</span>
            </div>
          ))}
        </div>

        {/* Upgrade button */}
        <button
          onClick={() => {
            // Navigate using SPA history so React renders the upgrade page
            const path = '/plan-' + requiredPlan;
            window.history.pushState({ section: 'plan-' + requiredPlan }, '', path);
            window.dispatchEvent(new PopStateEvent('popstate', { state: { section: 'plan-' + requiredPlan } }));
            onClose();
          }}
          style={{
            width: '100%',
            padding: '14px',
            background: plan.gradient,
            border: 'none',
            borderRadius: '12px',
            color: '#fff',
            fontSize: '15px',
            fontWeight: '800',
            cursor: 'pointer',
            letterSpacing: '0.3px',
            boxShadow: '0 8px 24px ' + plan.color + '40',
            transition: 'transform 0.15s, box-shadow 0.15s',
            marginBottom: '10px'
          }}
          onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 12px 32px ' + plan.color + '60'; }}
          onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 8px 24px ' + plan.color + '40'; }}
        >🚀 Upgrade to {plan.name}</button>

        <button
          onClick={onClose}
          style={{
            width: '100%',
            padding: '10px',
            background: 'transparent',
            border: 'none',
            color: '#64748b',
            fontSize: '13px',
            fontWeight: '600',
            cursor: 'pointer'
          }}
        >Maybe later</button>
      </div>
      <style>{`
        @keyframes modalSlide {
          from { opacity: 0; transform: translateY(20px) scale(0.96); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>
    </div>
  );
};

export default UpgradeModal;
